import { BaseRepresentativeClientEntity, FileTypeName } from 'api/types/entity';
import { TFunc } from 'libs/i18n';
import { parseIdentityDocumentInitialValue as parseBaseIdentityDocumentInitialValue } from 'modules/client/common/helpers';

import { IdentityDocumentFormType } from '../../forms/identityDocumentForm';

export const parseIdentityDocumentInitialValue = (
  t: TFunc,
  client: BaseRepresentativeClientEntity
) => {
  const values: IdentityDocumentFormType['identityDocument'] = {
    ...parseBaseIdentityDocumentInitialValue(t, client.identityDocument),
    files: [
      ...(client.selfieFiles || []).map((file) => ({
        ...file,
        type: FileTypeName.Selfie,
      })),
      ...(client.identityDocument?.files || []),
    ],
  };

  return values;
};
